import React, { Component } from 'react';
import { Redirect } from 'react-router-dom'
import { connect } from 'react-redux';
import { getMerchantDataFromReq } from 'actions/payment';

class ConnectApp extends Component {
    
    state = { redirectToPaymentPage: false, redirectToPayment: '/' }

	async componentDidMount() {
        const { errorCode } = this.props
        if(errorCode === '399'){
            this.setState({redirectToPayment: `/?errorCode=399`})
        }
        await this.props.getMerchantDataFromReq()
        this.setState({ redirectToPaymentPage: true })
    }

    render() {
        if(this.state.redirectToPaymentPage){
            return <Redirect to={this.state.redirectToPayment} />
        }else{
            return <p>Connecting...</p>
        }
    }

}

export default connect(null, { getMerchantDataFromReq })(ConnectApp);